import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { dataService } from "../../../Services/data/data.service";
import { Box } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { Link2 } from "lucide-react";
// Components
import Button from "../../Shared/Buttons/Button";
import HeaderBar from "../../Shared/Header/HeaderBar";
import HeaderTitle from "../../Shared/Header/HeaderTitle";
import HeaderEnd from "../../Shared/Header/HeaderEnd";
import TabSelector from "../../Shared/ui/TabSelector";
import Tab from "../../Shared/ui/Tab";
// Tabs
import PriceDefinitionTab from "./Components/Tabs/PriceDefinitionTab";
import PriceBundleTab from "./Components/Tabs/PriceBundleTab";
import AccountTab from "./Components/Tabs/AccountTab";
import AccountCategoryTab from "./Components/Tabs/AccountCategoryTab";
// Dialogs
import PriceAPIDialog from "./Components/PriceAPIDialog";

function FinancialCenterPage(props) {
  const classes = useStyles();
  const { t } = useTranslation();

  // General
  const [generalError, setGeneralError] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [userCompanies, setUserCompanies] = useState([]);

  // Price API Dialog
  const [priceAPIDialogOpen, setPriceAPIDialogOpen] = useState(false);

  // Fetch user companies on component mount
  useEffect(() => {
    if (props.Login.userid) {
      dataService
        .getUserAndCompanyData(props.Login.userid)
        .then((result) => {
          if (result) {
            setUserCompanies(result);
          }
        })
        .catch((error) => {
          console.error("Error fetching user companies:", error);
          setGeneralError(t('financialCenter.loadCompaniesFailed'));
        });
    }
  }, [props.Login.userid]);

  const openPriceAPIDialog = () => {
    setPriceAPIDialogOpen(true);
  };

  const closePriceAPIDialog = () => {
    setPriceAPIDialogOpen(false);
  };

  return (
    <React.Fragment>
      <Box className="page-container">
        <HeaderBar>
          <HeaderTitle>{t('nav.financialCenter')}</HeaderTitle>
          <HeaderEnd>
            <Button size="extraSmall" variant="secondary" startIcon={<Link2 />} onClick={openPriceAPIDialog}>
              {t('financialCenter.priceApi')}
            </Button>
          </HeaderEnd>
        </HeaderBar>
        <TabSelector value={selectedTab} onChange={setSelectedTab}>
          <Tab value={0} style={{ width: "10rem" }}>
            {t('financialCenter.priceDefinitions')}
          </Tab>
          <Tab value={1} style={{ width: "10rem" }}>
            {t('financialCenter.priceBundles')}
          </Tab>
          <Tab value={2} style={{ width: "10rem" }}>
            {t('financialCenter.accounts')}
          </Tab>
          <Tab value={3} style={{ width: "10rem" }}>
            {t('financialCenter.accountCategories')}
          </Tab>
        </TabSelector>
        {generalError && (
          <div className={classes.errorContainer}>
            <p className={classes.errorMessage}>{generalError}</p>
          </div>
        )}
        {selectedTab === 0 && (
          <div className={classes.tabContentContainer}>
            <PriceDefinitionTab {...props} />
          </div>
        )}
        {selectedTab === 1 && (
          <div className={classes.tabContentContainer}>
            <PriceBundleTab {...props} />
          </div>
        )}
        {selectedTab === 2 && (
          <div className={classes.tabContentContainer}>
            <AccountTab {...props} />
          </div>
        )}
        {selectedTab === 3 && (
          <div className={classes.tabContentContainer}>
            <AccountCategoryTab {...props} />
          </div>
        )}
      </Box>

      {/* Price API Dialog */}
      <PriceAPIDialog 
        dialogOpen={priceAPIDialogOpen} 
        closeDialog={closePriceAPIDialog}
        userCompanies={userCompanies}
        {...props} 
      />
    </React.Fragment>
  );
}

export default FinancialCenterPage;

const useStyles = makeStyles({
  header: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: "16px",
    marginBottom: "16px",
  },

  tabContentContainer: {
    width: "100%",
    marginTop: "1rem",
    boxSizing: "border-box",
  },

  errorContainer: {
    width: "100%",
    backgroundColor: "#FDF3F3",

    border: "1px solid #FBE5E5",
    borderRadius: "6px",

    marginBottom: "16px",
    padding: "12px",
  },

  errorMessage: {
    fontSize: "16px",
    color: "#D84949",
  },
});